import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import PhoneInput from 'react-phone-input-2';
import { Backdrop } from "@mui/material";
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Box, Button, Grid, TextField, FormControl } from '@mui/material';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Footer from '../../components/Footer/Footer';
import NewNavBar from '../../components/NewNavBar/NewNavBar';
import environment from '../../environment/environment';
import CustomSpinner from '../../components/CustomeSpinner/CustomeSpinner';


const Profile = () => {
    const [userDetails, setUserDetails] = useState(null)
    const [fullName, setFullName] = useState('');
    const [userName, setUserName] = useState('')
    const [mobileNo, setMobileNo] = useState('');
    const [email, setEmail] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [dateOfBirthError, setDateOfBirthError] = useState('');
    const [fullNameError, setFullNameError] = useState('');
    const [mobileNoError, setMobileNoError] = useState('');
    const [emailError, setEmailError] = useState('');
    // const [updatePassword, setUpdatePassword] = useState('');
    // const [updatePasswordError, setUpdatePasswordError] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const statusList = ["Married", "Single"];
    const [annDate, setAnnDate] = useState('');
    const [annDateError, setAnnDateError] = useState('')
    const [marriedStatus, setMarriedStatus] = useState('');
    const [marriedStatusError, setMarriedStatusError] = useState('');
    // const [confirmPassword, setConfirmPassword] = useState('');
    // const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const todayDate = new Date();
    const adultMaxDate = new Date(todayDate.getFullYear() - 12, todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const adultMinDate = new Date(todayDate.getFullYear() - 100, todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const [isLoading, setIsLoading] = useState(false);

    const fetchUserData = async (userId) => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${environment.config.apiBaseUrl}auth/${userId}/getByUserId`);
            if (response && response.data) {
                setFullName(response.data.fullName || '');
                setUserName(response.data.username || '');
                setMobileNo(response.data.mobileNo || '');
                setEmail(response.data.email || '');
                setDateOfBirth(response.data.dateOfBirth || '');
                setMarriedStatus(response.data.marriedStatus || '');
                setAnnDate(response.data.anniversaryDate || '');
            }
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);
        } catch (error) {
            console.error('Error fetching user data:', error);
            toast.error('Something went wrong while fetching user data');
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = JSON.parse(token);
                setUserDetails(decoded);

                if (decoded.userId) {
                    fetchUserData(decoded.userId);
                }
            } catch (error) {
                console.error('Error parsing token:', error);
                localStorage.removeItem('token');
            }
        }
    }, []);

    const handleChangeFullName = (event) => {
        const value = event.target.value;
        if (!value) {
            setFullNameError('Please provide a valid information');
        } else {
            setFullNameError('');
        }
        setFullName(value);
    }

    const handleChangeEmail = (event) => {
        const value = event.target.value
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
            setEmailError('Please provide a valid information');
        } else if (!value) {
            setEmailError('Please provide a valid information');
        } else {
            setEmailError('');
        }
        const username = value.split("@")[0];
        setUserName(username);
        setEmail(value);
    }

    const handleChangeMobileNo = (event) => {
        const value = event.target.value;
        const mobileRegex = /^([+]\d{2})?\d{10}$/;
        if (!mobileRegex.test(value)) {
            setMobileNoError('Invalid mobile number format');
        } else {
            setMobileNoError('');
        }
        setMobileNo(value);
    };

    const handleEdit = () => {
        setIsEdit(true);
    }

    const handleCancle = () => {
        setIsEdit(false);
        setMarriedStatus('');
        setMarriedStatusError('');
        setAnnDate('');
        setAnnDateError('');
        // setUpdatePassword('');
        // setUpdatePasswordError('');
        setDateOfBirth('');
        setDateOfBirthError('');
        // setConfirmPassword('');
        // setConfirmPasswordError('');
    }

    const handleChangeMarriedStatus = (event) => {
        const value = event.target.value;
        if (!value) {
            setMarriedStatusError('Please provide valid information');
        } else {
            setMarriedStatusError('');
        }
        setMarriedStatus(value);

    }

    const handleChangeAnnDate = (event) => {
        const value = event.target.value;
        if (!value) {
            setAnnDateError('Please provide valid information');
        } else {
            setAnnDateError('');
        }
        setAnnDate(value);
    }

    // const handleChangeUpdatePassword = (event) => {
    //     const value = event.target.value;
    //     if (!value) {
    //         setUpdatePasswordError('Please provide valid information');
    //     } else {
    //         setUpdatePasswordError('');
    //     }
    //     setUpdatePassword(value);
    // }

    // const handleChangeConfirmPassword = (event) => {
    //     const value = event.target.value;
    //     if (!value) {
    //         setConfirmPasswordError('Please provide valid information');
    //     } else if (value !== updatePassword) {
    //         setConfirmPasswordError(`Password doesn't match`);
    //     } else {
    //         setConfirmPasswordError('')
    //     }
    //     setConfirmPassword(value);
    // }

    const handleChangeDateOfBirth = (e) => {
        const value = e.target.value;
        if (!value) {
            setDateOfBirthError('Please provid a valid information');
        } else {
            setDateOfBirthError('');
        }
        setDateOfBirth(value);
    };

    const handleUpdateProfile = async (event) => {
        setIsLoading(true);
        event.preventDefault();
        let isValid = true;
        if (!fullName) {
            setFullNameError('Please provide valid information');
            isValid = false;
        }
        if (!isValid) {
            return;
        }
        const requestBody = {
            fullName: fullName,
            email: email,
            marriedStatus: marriedStatus,
            mobileNo: mobileNo,
            dateOfBirth: dateOfBirth,
            // 'password': updatePassword,
            // confirmPassword: confirmPassword,
            "anniversaryDate": annDate,
            "roles": "User",
            userId: userDetails.userId,
            userName: userName,
            "authenticateUser": true,
            "tourismUid": "123",
            "userStatus": "1",
        }
        try {
            const response = await axios.put(`${environment.config.apiBaseUrl}auth/${userDetails.userId}/updateUser`, requestBody);
            if (response && response.data) {
                handleCancle();
                toast.success("User updated successfully");
                await fetchUserData(userDetails.userId);
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
                
            }
        } catch (error) {
            console.error('Update error:', error);
            toast.error('Something went wrong while updating');
        }
        window.scrollTo(0, 0);
    };

    return (
        <>
            <div style={{ backgroundColor: '#EBEDF2' }}>
                <Header />
                <NewNavBar />
                {isLoading &&
                    <Backdrop
                        sx={{
                            color: "#fff",
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            backdropFilter: "blur(5px)",
                            backgroundColor: "rgba(0, 0, 0, 0.4)"
                        }}
                        open={isLoading}
                    >
                        <CustomSpinner color="inherit" />
                    </Backdrop>
                }
                <Sidebar/>
                <Toaster
                    position="top-right"
                    reverseOrder={false}
                />
                <div className='container mb-5'>
                    <div className='card mt-5'>
                        <div className='card-header d-flex justify-content-between align-items-center'>
                            <div style={{ fontSize: '20px', fontWeight: '600' }}>Profile</div>
                            <div>
                                <button
                                    type="button"
                                    data-bs-toggle="tooltip"
                                    title="Edit Task"
                                    className="btn btn-link btn-md"
                                    onClick={handleEdit}
                                    style={{boxShadow:'none'}}
                                >
                                    <i className="fa fa-edit"></i>
                                </button>
                            </div>
                        </div>
                        <div className='card-body'>
                            <Grid container spacing={3} className='register-form' sx={{ marginTop: '20px' }}>
                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Full Name"
                                        variant="outlined"
                                        value={fullName}
                                        onChange={handleChangeFullName}
                                        disabled={!isEdit}
                                    />
                                    {fullNameError && <p style={{ color: "red", margin: "2px" }}>{fullNameError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Email Id"
                                        variant="outlined"
                                        value={email}
                                        onChange={handleChangeEmail}
                                        disabled
                                    />
                                    {emailError && <p style={{ color: "red", margin: "2px" }}>{emailError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <PhoneInput
                                        country={'in'}
                                        value={mobileNo}
                                        onChange={handleChangeMobileNo}
                                        inputStyle={{ width: '100%', height: '55px' }}
                                        countryCodeEditable={false}
                                        disabled={!isEdit}
                                    />
                                    {mobileNoError && <p style={{ color: "red", margin: "2px" }}>{mobileNoError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Username"
                                        variant="outlined"
                                        value={userName}
                                        disabled
                                    />
                                </Grid>
                                {isEdit &&
                                    <>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                label="Date of birth"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{
                                                    min: adultMinDate,
                                                    max: adultMaxDate
                                                }}
                                                value={dateOfBirth}
                                                onChange={handleChangeDateOfBirth}
                                                fullWidth

                                            />
                                            {dateOfBirthError && <p style={{ color: "red", margin: "2px" }}>{dateOfBirthError}</p>}
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <FormControl fullWidth error={Boolean(marriedStatusError)}>
                                                <InputLabel id="gender-label">Married Status</InputLabel>
                                                <Select
                                                    labelId="gender-label"
                                                    id="gender-select"
                                                    value={marriedStatus}
                                                    label="Married Status"
                                                    onChange={handleChangeMarriedStatus}

                                                >
                                                    {statusList.map((status) => (
                                                        <MenuItem key={status} value={status}>
                                                            {status}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {marriedStatusError && (
                                                    <p style={{ color: 'red', margin: '4px 14px 0 14px' }}>{marriedStatusError}</p>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        {marriedStatus === 'Married' &&
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField
                                                    label="Anniversary Date"
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{
                                                        min: adultMinDate,
                                                        max: adultMaxDate
                                                    }}
                                                    value={annDate}
                                                    onChange={handleChangeAnnDate}
                                                    fullWidth

                                                />
                                                {annDateError && <p style={{ color: "red", margin: "2px" }}>{annDateError}</p>}
                                            </Grid>
                                        }
                                        {/* <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                fullWidth
                                                type='password'
                                                label="Update Password"
                                                variant="outlined"
                                                value={updatePassword}
                                                onChange={handleChangeUpdatePassword}
                                            />
                                            {updatePasswordError && <p style={{ color: "red", margin: "2px" }}>{updatePasswordError}</p>}
                                        </Grid> */}
                                        {/* <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                fullWidth
                                                type='password'
                                                label="Confirm Password"
                                                variant="outlined"
                                                value={confirmPassword}
                                                onChange={handleChangeConfirmPassword}
                                            />
                                            {confirmPasswordError && <p style={{ color: "red", margin: "2px" }}>{confirmPasswordError}</p>}
                                        </Grid> */}
                                    </>
                                }
                                {isEdit &&
                                    <>
                                        <Grid item xs={12} md={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 3 }}>
                                            <Button className='mb-4 mt-3' type="submit" variant="contained" style={{ backgroundColor: 'lightgray', color: '#2d2b29', height: '48px' }} onClick={handleCancle}>
                                                Cancle
                                            </Button>
                                            <Button className='mb-4 mt-3' type="submit" variant="contained" color="primary" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '48px' }} onClick={handleUpdateProfile} >
                                                Update
                                            </Button>
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default Profile